window.mmajaxcart = {
  AjaxcartOpen: function() {
    let body = document.querySelector("body"),
    ajaxCart = document.querySelector(".mm-ajaxcart"),
    ajaxOverlay = document.querySelector(".mm-ajaxcart-overlay");
    body.classList.add("overflow-hidden"),
    ajaxCart.classList.add("has--opened"),
    ajaxOverlay.classList.add("has--active")
  },
  AjaxcartClose: function() {
    let body = document.querySelector("body"),
    ajaxCart = document.querySelector(".mm-ajaxcart"),
    ajaxOverlay = document.querySelector(".mm-ajaxcart-overlay");
    body.classList.remove("overflow-hidden"), ajaxCart.classList.remove("has--opened"), ajaxOverlay.classList.remove("has--active");
  },
  AjaxcartRender: function() {
    return fetch("/cart?view=mm-ajax").then((function(response) {
      return response.text()
    })).then((function(cart) {

      // removing COD product
      const parser = new DOMParser();
      const cartHTML = parser.parseFromString(cart, 'text/html');
      const cartItems = cartHTML.getElementById('cart-items')?.textContent;
      const cartItemsJSON = cartItems && JSON.parse(cartItems);

      if (cartItemsJSON && cartItemsJSON.some(item => item.variant_id === 40332006097095)) {
        const data = {
          'id': '40332006097095',
          'quantity': 0
        }

        window.mmajaxcart.AjaxcartChangeHandler(data)
      } else {
        document.querySelector(".mm-ajaxcart").innerHTML = cart;
        if (document.querySelector('.cart-annoncement-slider') && typeof Splide !== 'undefined') {
          const AnnouncementSlider = new Splide( '.cart-annoncement-slider', {
            type: 'slide',
            perPage: 1,
            pagination: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
          });
          AnnouncementSlider.mount();
        }
      }
      if (document.querySelector('.cart-drawer-bundle-slick') && typeof Splide !== 'undefined') {
        const BundleSlider = new Splide('.cart-drawer-bundle-slick', {
          type: 'slide',
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: true,
          rewind: true
        });
        BundleSlider.mount();
      }

    })).catch((function(err) {
      console.log("Error:", err)
    }))
  },
  AjaxcartChangeHandler: function(data) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    }).then((function(response) {
      return response.json()
    })).then((function(cart) {
      mmajaxcart.AjaxcartRender();
      let CartCount = cart.item_count;
      cart.items.forEach(element => {
        const event = new CustomEvent('cartDataUpdate', {
            detail: { variant : element.id, quantity: element.quantity }
          });
          document.dispatchEvent(event);
      });
      
      document.querySelector(".cart-count-bubble span").innerHTML = CartCount;
      const event = new Event("cartUpdate");
      document.dispatchEvent(event);
      //===================== 
      // view cart GA4 event call
      // ========================
      const evt = new Event("cart-update")
      document.dispatchEvent(evt);
    })).catch((function(err) {
      console.log("Error:", err)
    }))
  },
  AjaxcartQuantityChange: function() {
    document.querySelector(".mm-ajaxcart").addEventListener("change", (function(e) {
      e.stopPropagation();
      if ("quantity-input" === e.target.className) {

        let isBundel = e.target.dataset.bundel
        let isCollectionBundel = e.target.dataset.collectionBundel
        let maxBundelQty = parseInt(e.target.dataset.maxQuantity)
        let maxCollectionQty = parseInt(e.target.dataset.maxCollectionQuantity)
        let count = parseInt(e.target.value)

        if (isBundel == 'true' && (count >= maxBundelQty)) {
          let evt = e.target,
            updatedQuantity,
            quantityLine,
            params = {
              quantity: parseInt(maxBundelQty),
              line: parseInt(evt.getAttribute("data-line"))
            };
          mmajaxcart.AjaxcartChangeHandler(params)

        } else if (isCollectionBundel == 'true' && (count >= maxCollectionQty)) {
          let evt = e.target,
            updatedQuantity,
            quantityLine,
            params = {
              quantity: parseInt(maxCollectionQty),
              line: parseInt(evt.getAttribute("data-line"))
            };
          mmajaxcart.AjaxcartChangeHandler(params)
        } else {
          let evt = e.target,
            updatedQuantity,
            quantityLine,
            params = {
              quantity: parseInt(evt.value),
              line: parseInt(evt.getAttribute("data-line"))
            };
          mmajaxcart.AjaxcartChangeHandler(params)
          const variantId = (evt.getAttribute('data-key').split(":"))[0]

        }

      }
    }))
  },
  AjaxcartQuantityHandler: function() {
    document.querySelector(".mm-ajaxcart").addEventListener("click", (function(e) {
      e.stopPropagation();
      if ("quantity-plus" === e.target.className) {
        let isBundel = e.target.dataset.bundel
        let isCollectionBundel = e.target.dataset.collectionBundel
        let maxBundelQty = parseInt(e.target.dataset.maxQuantity)
        let maxCollectionQty = parseInt(e.target.dataset.maxCollectionQuantity)

        let count = e
          .target
          .parentNode
          .querySelector(".quantity-input")
          .value
          

        if (isBundel == 'true' && count >= maxBundelQty) {
          alert(`Sorry, you can't add more quantity.`);

        } else if (isCollectionBundel == 'true' && count >= maxCollectionQty) {
          alert(`Sorry, you can't add more quantity.`);

        } else {
          let evt = e.target,
            q = evt.parentNode.querySelector(".quantity-input").value,
            i,
            p = parseInt(1),
            u = parseInt(q) + p;
          evt.parentNode.querySelector(".quantity-input").value = u;
          let updatedQuantity,
            quantityLine,
            params = {
              quantity: parseInt(evt.parentNode.querySelector(".quantity-input").value),
              line: parseInt(evt.parentNode.querySelector(".quantity-input").getAttribute("data-line"))
            };
          mmajaxcart.AjaxcartChangeHandler(params)
        }

      }if ("quantity-minus" === e.target.className) {
        let evt = e.target,
          q = evt.parentNode.querySelector(".quantity-input").value,
          i,
          p = parseInt(1),
          u = parseInt(q) - p;
        evt.parentNode.querySelector(".quantity-input").value = u;
        let updatedQuantity,
          quantityLine,
          params = {
            quantity: parseInt(evt.parentNode.querySelector(".quantity-input").value),
            line: parseInt(evt.parentNode.querySelector(".quantity-input").getAttribute("data-line"))
          };
          
          const variantId = evt.parentNode.querySelector(".quantity-input").getAttribute('data-key').split(":")[0]  
          if (u < 1) {
            const event = new CustomEvent('cartDataUpdate', {
              detail: { variant : variantId, quantity: 0 }
            });
            document.dispatchEvent(event);
          }
        mmajaxcart.AjaxcartChangeHandler(params)
      }
      if ("mm-ajaxcart-close" === e.target.className) {
      mmajaxcart.AjaxcartClose();
    }
    }))
  },
  AjaxcartRemoveItem: function() {
    document.querySelector(".mm-ajaxcart").addEventListener("click", (function(e) {
      e.stopPropagation();
      if ("mm-ajaxcart-remove-item" === e.target.className) {
        let evt = e.target,
          removeLine,
          params = {
            quantity: 0,
            line: parseInt(evt.getAttribute("data-line"))
          };

        const parentEle = evt.parentNode.closest('.mm-ajaxcart-item-info')
        const variantId = parentEle.querySelector(".quantity-input").getAttribute('data-key').split(":")[0]  
        const event = new CustomEvent('cartDataUpdate', {
          detail: { variant : variantId, quantity: 0 }
        });
        document.dispatchEvent(event);

        mmajaxcart.AjaxcartChangeHandler(params)
      }
    }))
  }
},

  document.querySelector(".mm-ajaxcart-open")?. addEventListener("click", (function(e) {
    e.preventDefault(),
    mmajaxcart.AjaxcartRender()
    mmajaxcart.AjaxcartOpen()

  })),
  document.addEventListener("click", function(e) {
    const isCartButton = e.target.closest(".mm-ajaxcart-button");
    const isCloseButton = e.target.closest(".mm-ajaxcart-close");

    if (isCartButton || isCloseButton) {
      mmajaxcart.AjaxcartClose();
    }
  });
  document.querySelector(".mm-ajaxcart-overlay").addEventListener("click", (function(e) {
    e.preventDefault(),
    mmajaxcart.AjaxcartClose()
  })),
  mmajaxcart.AjaxcartRemoveItem(),
  mmajaxcart.AjaxcartQuantityHandler(),
  mmajaxcart.AjaxcartQuantityChange()